"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEIGHT = void 0;
var react_1 = __importDefault(require("react"));
var Link_1 = __importDefault(require("../Link"));
var typography_1 = require("../../typography");
var Button_1 = __importDefault(require("../../basics/Button"));
var Pill_1 = __importDefault(require("../../misc/Pill"));
var HorizontalSpacer_1 = __importDefault(require("../../utils/HorizontalSpacer"));
var DropdownMenu_1 = __importDefault(require("../../misc/DropdownMenu"));
var UserDropdownMenu_1 = __importDefault(require("../UserDropdownMenu"));
var theme_1 = require("../../../theme");
var styles_1 = require("./styles");
var Banner_1 = __importDefault(require("./components/Banner"));
var Menu_1 = __importDefault(require("./components/Menu"));
var styles_2 = require("./components/Menu/styles");
var IconButton_1 = __importDefault(require("./components/IconButton"));
var HS_1 = { small: 4, medium: 6, large: 8 };
var SiteHeader = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, logInButton = _a.logInButton, bannerHref = _a.bannerHref, logoHref = _a.logoHref, bannerOnClose = _a.bannerOnClose, bannerText = _a.bannerText, closeOn = _a.closeOn, user = _a.user, _c = _a.userItems, userItems = _c === void 0 ? [] : _c, showOn = _a.showOn, _d = _a.extraActions, extraActions = _d === void 0 ? [] : _d, _e = _a.iconButtons, iconButtons = _e === void 0 ? [] : _e, logo = _a.logo, _f = _a.hideable, hideable = _f === void 0 ? true : _f, _g = _a.isTransparent, isTransparent = _g === void 0 ? false : _g, _h = _a.isCompact, isCompact = _h === void 0 ? false : _h, _j = _a.navBarAriaLabel, navBarAriaLabel = _j === void 0 ? 'Site navigation' : _j, commonProps = __rest(_a, ["items", "logInButton", "bannerHref", "logoHref", "bannerOnClose", "bannerText", "closeOn", "user", "userItems", "showOn", "extraActions", "iconButtons", "logo", "hideable", "isTransparent", "isCompact", "navBarAriaLabel"]);
    var _k = __read(react_1.default.useState(false), 2), menuIsOpen = _k[0], setMenuIsOpen = _k[1];
    react_1.default.useEffect(function () {
        setMenuIsOpen(false);
    }, [closeOn]);
    react_1.default.useEffect(function () {
        var mQ = window.matchMedia(theme_1.theme.breakpoints.large);
        /*
          We make sure to close the menu when transitioning to a large
          enough viewport width where it wouldn't appear anyway
        */
        var handleWidthChange = function (ev) {
            if (ev.matches && menuIsOpen) {
                setMenuIsOpen(false);
            }
        };
        handleWidthChange(mQ);
        var supportsChangeEvent = true;
        try {
            mQ.addEventListener('change', handleWidthChange);
        }
        catch (e) {
            try {
                // Support Safari versions <14
                mQ.addListener(handleWidthChange);
                supportsChangeEvent = false;
            }
            catch (e2) {
                console.error(e2);
            }
        }
        return function () {
            return supportsChangeEvent
                ? mQ.removeEventListener('change', handleWidthChange)
                : mQ.removeListener(handleWidthChange);
        };
    }, [menuIsOpen]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        menuIsOpen && react_1.default.createElement(styles_2.Cover, null),
        bannerText && react_1.default.createElement(Banner_1.default, { onClose: bannerOnClose }, bannerText),
        react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "SiteHeader" }, commonProps),
            react_1.default.createElement(styles_1.NavBar, { "aria-label": navBarAriaLabel, "$isOpen": menuIsOpen, "$isTransparent": isTransparent, "$isCompact": isCompact },
                react_1.default.createElement(styles_1.Logo, { href: logoHref, ariaLabel: "Go to homepage", "$isCompact": isCompact }, logo),
                react_1.default.createElement(styles_1.NavItems, null, items.map(function (item, i) {
                    var content = (react_1.default.createElement(HorizontalSpacer_1.default, { amount: HS_1 },
                        react_1.default.createElement(typography_1.Body, { level: "3", inline: true }, item.display),
                        item.isNew && react_1.default.createElement(Pill_1.default, null, "New!")));
                    if (item.href) {
                        return (react_1.default.createElement(styles_1.NavItem, { key: i },
                            react_1.default.createElement(Link_1.default, { href: item.href, color: "GREY_90", hoverColor: "BLUE_50" }, content)));
                    }
                    return (react_1.default.createElement(styles_1.NavItem, { key: i },
                        react_1.default.createElement(DropdownMenu_1.default, { maxHeight: "80vh", zIndex: 1, anchor: function (_a) {
                                var isOpen = _a.isOpen, props = __rest(_a, ["isOpen"]);
                                return (react_1.default.createElement(styles_1.AnchorButton, __assign({}, props),
                                    content,
                                    react_1.default.createElement(styles_1.Chevron, { "$isActive": isOpen })));
                            }, items: [{ items: item.items }], closeOn: closeOn })));
                })),
                react_1.default.createElement(styles_1.Actions, null,
                    extraActions.map(function (_a, i) {
                        var display = _a.display, href = _a.href, extraAction = __rest(_a, ["display", "href"]);
                        return href ? (react_1.default.createElement(styles_1.ExtraAction, { key: i },
                            react_1.default.createElement(Link_1.default, __assign({}, extraAction, { href: href, color: "BLUE_50", hoverColor: "BLUE_60" }),
                                react_1.default.createElement(typography_1.Body, { level: "3" }, display)))) : (react_1.default.createElement(styles_1.ExtraAction, { key: i },
                            react_1.default.createElement(typography_1.Body, { level: "3" }, display)));
                    }),
                    iconButtons.map(function (iconButton, i) { return (react_1.default.createElement(IconButton_1.default, __assign({ key: i }, iconButton))); }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(styles_1.UserItems, null, !user ? (react_1.default.createElement(Button_1.default, __assign({}, logInButton), logInButton.text)) : (react_1.default.createElement(UserDropdownMenu_1.default, { user: user, items: userItems, closeOn: closeOn }))),
                        react_1.default.createElement(styles_1.MenuButton, { onClick: function () { return setMenuIsOpen(!menuIsOpen); }, iconName: menuIsOpen ? 'close' : 'menu', ariaLabel: menuIsOpen ? 'Close menu' : 'Open menu' })))),
            react_1.default.createElement(Menu_1.default, { isOpen: menuIsOpen, items: __spreadArray(__spreadArray([], __read(items.map(function (item) { return ({
                    label: item.items ? item.display : undefined,
                    items: item.items ? item.items : [item],
                }); })), false), __read(userItems), false), user: user, logInButton: logInButton, extraActions: extraActions }))));
};
var styles_3 = require("./styles");
Object.defineProperty(exports, "HEIGHT", { enumerable: true, get: function () { return styles_3.HEIGHT; } });
exports.default = SiteHeader;
